import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import styled from 'styled-components';
import CheckboxStyles from '../Inputs/Checkbox/Checkbox.styles';
const Container = styled.section `
  ${setCssVar('accentColor', brand.hta.green)};
  ${setCssVar('bgColor', brand.greyVeryLight)};
  ${setCssVar('bgColorAlt', brand.white)};
  ${setCssVar('fgColor', brand.black)};

  .theme-rss & {
    ${setCssVar('accentColor', brand.rss.green)};
    ${setCssVar('bgColor', brand.rss.grey)};
    ${setCssVar('bgColorAlt', brand.white)};
    ${setCssVar('fgColor', brand.white)};
  }

  .theme-apl & {
    ${setCssVar('accentColor', brand.apl.green)};
    ${setCssVar('bgColor', brand.greyVeryLight)};
    ${setCssVar('bgColorAlt', brand.white)};
    ${setCssVar('fgColor', brand.black)};
  }

  .theme-rss & {
    ${setCssVar('accentColor', brand.rss.green)};
    ${setCssVar('bgColor', brand.rss.grey)};
    ${setCssVar('bgColorAlt', brand.white)};
    ${setCssVar('fgColor', brand.white)};
  }

  display: flex;
  flex-wrap: wrap;
  margin: 22px 0;

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const Open = styled.button `
  display: flex;
  align-items: center;
  background: none;
  border: 1px solid ${brand.black};
  border-radius: 11px;
  color: ${brand.black};
  height: 48px;
  padding: 0 16px;

  .theme-rss & {
    border: 1px solid ${cssVar('fgColor')};
    color: ${cssVar('fgColor')};
  }

  > svg {
    display: block;
    height: 14px;
    margin-left: 16px;
    width: 14px;
  }

  > span {
    ${fonts.sourceSansPro.regular};
    font-size: 20px;
    line-height: 32px;

    strong {
      color: ${brand.grey};
      ${fonts.sourceSansPro.semiBold};
    }
  }

  ${CheckboxStyles.Container} {
    margin-left: 0;
  }
`;
const Overlay = styled.div `
  position: fixed;
  top: 0;
  right: 0;
  background: ${brand.white};
  height: 100dvh;
  overflow: auto;
  transform: translateX(100vw);
  transition: transform 0.3s ease-out;
  width: calc(100% - 48px);
  z-index: ${Layers.Modal};

  .theme-rss & {
    background: ${cssVar('bgColor')};
  }

  [aria-active='true'] & {
    transform: translateX(0vw);
  }
`;
const Close = styled.button `
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  color: ${brand.white};
  height: 48px;
  justify-content: center;
  margin: 0;
  padding: 0;
  transform: translateX(-100%);
  width: 48px;

  > svg {
    display: block;
    height: 20px;
    width: 20px;
  }

  > span {
    ${srOnly};
  }
`;
const Background = styled.div `
  position: fixed;
  top: 0;
  right: 0;
  background: ${brand.black};
  height: 100%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-out;
  width: 100%;
  z-index: ${Layers.Modal - 1};

  [aria-active='true'] & {
    opacity: 0.85;
    pointer-events: all;
  }
`;
const SelectedFilters = styled.div `
  flex: 1 0 100%;
`;
export default {
    Background,
    Close,
    Container,
    Open,
    Overlay,
    SelectedFilters,
};
